import { Outlet } from 'react-router'
import Header from '../../../component/layout/header'
import useNav from '../../../component/custom-hooks/get-nav';

const ProductSummaryLayout = () => {

  const navList = useNav();
  let {MainSummaryTopNav, SummaryBottomNav} = navList;

  return (
    <div className="webBody">
      <Header bottomTabs={SummaryBottomNav} topTabs={MainSummaryTopNav} />
      <Outlet />
    </div>
  )
}

export default ProductSummaryLayout